import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UsersService } from '../services/users.service';
import * as $ from 'jquery';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  FNameRequired:boolean = false ; FNameNumbers:boolean = false ; LNameRequired:boolean = false ;LNameNumbers:boolean = false ; EmailRequired:boolean = false ; EmailValid:boolean =false ; 
  PasswordRequired:boolean=false ; RepeatRquired:boolean = false ; RepeatMatch:boolean = false ;EmailUnique:boolean = false 
  @Output()gotoprofile = new EventEmitter();
  @Output () changView = new EventEmitter() ; 
  newUser ; try:boolean = false 
  constructor(private Allusers:UsersService , private router:Router) { }

  ngOnInit() {

     /****************jquery****************** */
     $(document).ready(function(){

      $(".fa-eye").click(function(){
        $(this).toggleClass('fa-eye-slash');
        if($(this).hasClass("fa-eye-slash"))
        {
          $(this).parent().prev().children( "input" ).attr('type',"text") ;
        }
        else
        {
          $(this).parent().prev().children( "input" ).attr('type',"password") ;
        }
      
      });

     


    });
  }

  checkRegister()
  {
    var y = 0 
    var FN = (<HTMLInputElement>document.getElementById('FName')).value ; 
    var LN = (<HTMLInputElement>document.getElementById('LName')).value  ; 
    var Email = (<HTMLInputElement>document.getElementById('Email')).value  ; 
    var Password = (<HTMLInputElement>document.getElementById('Password')).value  ; 
    var RPassword = (<HTMLInputElement>document.getElementById('RPassword')).value  ; 
    
     

    if(FN === '')
    {
      this.FNameRequired = true ; 
      this.FNameNumbers = false  ; 
     
      y += 1 ; 
  
  

    }
   
    else
    {
      this.FNameRequired = false   ;
      this.FNameNumbers = false  ;
    }


    if(LN === '')
    {
      this.LNameRequired = true ; 
      this.LNameNumbers = false  ; 
      y+= 1 
    }
   
    else
    {
      this.LNameRequired = false 
      this.LNameNumbers = false ;
    }



    if(Email === '')
    {
      this.EmailRequired = true ; 
      this.EmailValid = false  ;
      this.EmailUnique = false
      y += 1  
    }
    else if(Email.indexOf('@') === -1 )
    {
      this.EmailRequired = false ; 
      this.EmailValid = true  ; 
      this.EmailUnique = false
      y += 1 
      
    }
    else if (this.checkUnique(Email))
    {
      this.EmailRequired = false ; 
      this.EmailValid = false  ; 
      this.EmailUnique = true
      y += 1 
      
    }
    else
    {
      this.EmailRequired = false 
      this.EmailValid = false 
      this.EmailUnique = false
    }

    if(Password === '')
    {
      this.PasswordRequired = true ;
      y += 1 
     
    }
    else
    {
      this.PasswordRequired = false ;
    }

    if(RPassword === '')
    {
      this.RepeatRquired = true 
      this.RepeatMatch = false ; 
      y += 1 
     
    }
    else if (Password !== RPassword)
    {
      this.RepeatRquired = false 
      this.RepeatMatch = true ;
      y += 1 
    }
    else
    {
      this.RepeatRquired = false 
      this.RepeatMatch = false ;
    }

   
    if(y>0)
    {
     
      
      document.getElementById("register").classList.add('animated', 'bounce')
      setTimeout(function(){
        document.getElementById('register').classList.remove('bounce')
      },1000) ; 
     

      
    }
    else
    {
     this.Allusers.showNavbar = true ;
      
      this.newUser = 
      {
        id:this.Allusers.users.length + 1 , 
        firstName:FN , 
        lastName :LN , 
        email :Email , 
        password :Password 

      }
      this.Allusers.users.push(this.newUser); 
      this.Allusers.currentUser = this.Allusers.users.length  ;
      (<HTMLFormElement>document.getElementById('register')).reset() ; 
    
      this.gotoprofile.emit()
      this.changView.emit()
      this.router.navigate[("/login")]      

    }

   
  }
  checkUnique(Email):boolean
  {
    this.Allusers.users 
    for(let user of this.Allusers.users )
    {
      if(user.email === Email )
      {
        return true ; 
        break ;
      }
    }
  }


}
